import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Employee } from "../../../model/user";
import { EMPLOYEE_STATE } from "../../../shared/enums";

const initialState: {
  employees: Employee[];
  state: EMPLOYEE_STATE;
  pending: boolean;
  error: { value: boolean; message?: string; code?: string };
} = {
  employees: [],
  state: EMPLOYEE_STATE.fetching,
  pending: false,
  error: { value: false, message: "" },
};

export const employeeStore = createSlice({
  name: "employee-reducer",
  initialState,
  reducers: {
    employeesFetchStart(state) {
      return { ...state, pending: true, state: EMPLOYEE_STATE.fetching };
    },
    employeesFetchSuccess(state, action: PayloadAction<Employee[]>) {
      return {
        ...state,
        pending: false,
        error: { value: false },
        state: EMPLOYEE_STATE.fetchEmployeesSuccess,
        employees: action.payload,
      };
    },
    employeesFetchFail(state) {
      return {
        ...state,
        error: { value: true, message: "Error fetching employees" },
        state: EMPLOYEE_STATE.fetchEmployeesFail,
      };
    },
  },
});

export const {
  employeesFetchFail,
  employeesFetchStart,
  employeesFetchSuccess,
} = employeeStore.actions;
